<!--
 * @Author: Gaho
 * @Date: 2024-04-19 10:38:21
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-12 17:29:55
 * @Description: 这是选头像、上传头像、拍照头像，并裁切的上弹组件 
上传图片自定义头像的功能已经开始，但后来被废弃了，
因为不能开放自定义功能，防止用户在头像上打广告 
-->
<template>
    <ModalTitle
        v-model="showModalSelf"
        :backdrop="true" 
        @update:model-value="onUpdateModelVisible"
        class="round-details"
        scopeid=""
    >
        <template v-slot:header>
            <div class="flex justify-between flex-1">
                {{ $t('avatar.ChangeTheAvatar') }}
            </div>
        </template>
        <!--
            ↑ 顶部 header
            ↓ 这是弹出窗口的核心内容
        -->
        <!-- ↓ 上传中的页面 -->
        <section class="uploading-box"
            v-if="['uploading', 'uploaded', 'uploadFailed'].includes(sUploadingStatus)" 
        >
            <UserAvatar
                class=""
                size='200px'
                :src="oPictureCipped"
            />
            <div class="uploading-tips">
                <template v-if="sUploadingStatus === 'uploading'">
                    {{ $t('avatar.uploading') }}
                    <q-icon name="file_upload"
                        class="animate-bounce"
                    />
                </template>
                <template v-else-if="sUploadingStatus == 'uploaded'">
                    {{ $t('avatar.uploaded') }}
                    <q-icon name="download_done"/>
                    <ButtonGrayButton
                        class="ml-2"
                        :fullWidth="false"
                        @click="() => onUpdateModelVisible(false)"
                    >
                        {{ $t('commonInfo.close') }}
                    </ButtonGrayButton>
                </template>
                <template v-else-if="sUploadingStatus == 'uploadFailed'">
                    {{ $t('avatar.uploadFailed') }}
                    <q-icon name="close"/>
                    <ButtonGrayButton
                        class="ml-2"
                        :fullWidth="false"
                        @click="sUploadingStatus = ''"
                    >
                        {{ $t('commonInfo.goBack') }}
                    </ButtonGrayButton>
                </template>
            </div>
        </section>
        <!-- 
            ↑ 上传中
            ↓ 默认状态 
        -->
        <template v-else>
            <ul class="default-list">
                <li v-for="(cur) of aDefaultNames"
                    :key="cur"
                    :class="{
                        active: (sAvatarChosen || sAvatarCurrent) == cur,
                    }"
                    @click="sAvatarChosen = cur"
                >
                    <UserAvatar
                        size='60px'
                        class="avatar"
                        :avatarName="cur"
                    ></UserAvatar>
                    <span class="tick">
                        <q-icon name="done" />
                    </span>
                </li>
            </ul>
            <div class="confirm-bar"
                v-show="sAvatarChosen && (sAvatarChosen != sAvatarCurrent)"
            >
                <ButtonGrayButton :fullWidth="false"
                    @click="setDefaultAvatar"
                >
                    {{ $t('commonInfo.confirmBtn') }}
                </ButtonGrayButton>
                <ButtonGrayButton :fullWidth="false"
                    @click="sAvatarChosen = ''"
                >
                    {{ $t('Cancel') }}
                </ButtonGrayButton>
                <!-- ↓ 测试专用 -->
                
            </div>
        </template>
        <!-- 
            ↓ 最下方沉底的按钮（拍照与上传）  
            ↓ 暂时关闭上传功能，防止被用于打广告渠道 
        -->
        <!-- <div class="btn-group"
            v-if="sUploadingStatus == ''"
        >
            <button class="btn-gray"
                @click="fnShowFilmingStage" 
            >
                <q-icon name="camera_alt"/>
                {{ $t('avatar.TakePictures') }}
            </button>
            <label class="btn-gray">
                <q-icon name="perm_media"
                    class=""
                />
                {{ $t('avatar.Upload') }}
                <input
                    type="file" 
                    v-show="0"
                    accept="image/png, image/jpg, image/jpeg, image/webp, image/gif"
                    @change="fnSetFile"
                />
            </label>
        </div> -->
    </ModalTitle>
    <!--
        ↓ 剪切弹窗 
    -->
    <Teleport to="body">
        <div class="cutting-stage"
            v-if="showPicCuttingStage"
        >
            <div class="top-area"
                :ref="el => oContainerDOM = el"
                :style="{'min-height': sCropperCanvasHeight }" 
            >
                <!-- 裁切图像组件将插入到此 -->
            </div>
            <div class="flex justify-center">
                <ButtonGrayButton
                    :fullWidth="false"
                    @click="fnRotate"
                >
                    {{ $t('avatar.rotate') }} 
                </ButtonGrayButton>
                &nbsp;
                <ButtonGrayButton
                    :fullWidth="false"
                    @click="fnResetPic2Center"
                >
                    {{ $t('avatar.reset') }}
                </ButtonGrayButton>
            </div>
            <div class="btn-bar">
                <button
                    class="btn-gray"
                    @click="() => showPicCuttingStage = !showPicCuttingStage"
                >
                    {{ $t('Cancel') }}
                </button>
                <ButtonThe3DButton
                    color="red"
                    size="lg"
                    @click="fnConfirmAndUpload" 
                    v-click-and-rest 
                >
                    {{ $t('commonInfo.confirm') }}
                </ButtonThe3DButton>
            </div>
        </div>
    </Teleport>
    <!--
        ↓ 拍照组件 
    -->
    <Teleport to="body">
        <div class="filming-stage"
            v-if="showFilmingStage"
        >
            <camera
                autoplay
                :resolution="{ width: oScreenSize.width, height: void 0 }"
                :ref="el => oCamera = el"
                @error="fnCameraError"
            ></camera>
            <div class="floating-btns">
                <button
                    @click="showFilmingStage = false"
                >   
                    <!-- keyboard_arrow_left -->
                    <q-icon name="reply"/> 
                </button>
                <button class="snapshot"
                    @click="fnSnapshot"
                >
                    <q-icon name="radio_button_checked"/>
                </button>
                <button @click="switchCamera">
                    <!-- sync -->
                    <q-icon name="cameraswitch"/>
                </button>
            </div>
        </div>
    </Teleport>
</template>

<script lang="ts" setup>
import Camera from "simple-vue-camera";
import { useAuthSocket } from '@/socket/auth';
import { useUserStore } from '~/stores/user';
import {useUpload} from '@/api/upload/index';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
});

type Uploading = '' | 'uploading' | 'uploaded' | 'uploadFailed'; 
const CDN = useRuntimeConfig().public.CDN;
const oAvatar = getAvatars(); // 前端的默认头像库，
const aDefaultNames = Object.keys(oAvatar);
const { EMIT_NEW_AVATAR } = useAuthSocket();
const { UPLOAD_FILE } = useUpload();
const userStore = useUserStore();
const sCropperCanvasHeight = '40vh';
const iLoadingAnimation = 1_600; // 上传动画耗时 
const oRoute = useRoute();
const sFirstPath = oRoute.path;

const oScreenSize = {
    width: window.innerWidth,
    height: window.innerHeight,
};

const oCropperModule = (
    import.meta.server
    ? null
    : Promise.any([
        /* 此地址已经设为 prefetch  */
        import(/* @vite-ignore */CDN.cropperjs01),
        import(/* @vite-ignore */CDN.cropperjs02),
    ])
);

// ↑ 导入内容、和一些恒定值
// ↓ 本地数据 ========================================================================== 

const showModalSelf = ref(!!props.modelValue);
const showPicCuttingStage = ref(false); 
const showFilmingStage = ref(false); 
// ↑ 窗口可见性管理 ----------------------------------- 

const sAvatarChosen = ref(''); // 刚选中的默认头像的【名称】
const oContainerDOM = ref(null); // Cropper 插件的容器 
const oPicture4clip = ref(null); // 待剪切的图（导入或拍摄的图）
const oPictureCipped = ref(null); // 裁剪后的图，也赋值为默认头像的 src 地址 

const sUploadingStatus = ref<Uploading>(''); 

const oCamera = ref(null); 
let oMyCropper = null; // 剪切组件实例，打开裁剪窗口时赋值到此 

// 当前头像【名】
// 如果用户没选用“默认头像” 例如上传了头像，那些这里返回空 
const sAvatarCurrent = computed(()=>{
    const avatar = userStore.avatar || '';
    const isDefault = avatar.startsWith(sDefaultAvatarPrefix);
    if (!isDefault) return;
    const avatarName = avatar.slice(
        sDefaultAvatarPrefix.length,
    );
    return avatarName
});

const emits = defineEmits([
    'update:modelValue',
]);

/**
 * 控制窗口自身开/关 
 */
const onUpdateModelVisible = (value: boolean) => {
    showModalSelf.value = !!value; 
    emits('update:modelValue', !!value); 
};


/**
 * 裁剪图居中（复位） 
 */
const fnResetPic2Center = async ()=>{
    if (!oMyCropper){
        return console.error('裁剪组件未加载 at fnResetPic2Center()');
    }
    const oSection = oMyCropper.getCropperSelection();
    oSection.$change(0, 0, 240, 240); 
    oSection.$center();
    const img = oMyCropper.getCropperImage();
    img.$resetTransform();
    img.$center('contain');
};

const fnRotate = ()=>{
    if (!oMyCropper){
        return console.error('裁剪组件未加载 at fnRotate()');
    }
    const img = oMyCropper.getCropperImage();
    img.$rotate('90deg'); 
};

/**
 * 显示裁切组件（选定本地图之后调用） 
 */
const showCuttingStage = async ()=>{
    showPicCuttingStage.value = true; 
    await nextTick(); // 等 dom 加载 
    await nextTick();
    PicCuttinginitialize();
};

/**
 * 显示【拍照】组件
 */
const fnShowFilmingStage = async ()=>{
    console.log('准备拍照'); 
    showFilmingStage.value = true; 
};

/**
 * 监控相机调用的错误 
 */
const fnCameraError = (error: Error) => {
    console.log("error", error);
    showFilmingStage.value = false; 
    showNegativeNotify({
        i18n: 'avatar.noCameraAuthorization',
    });
}

/**
 * 拍照，并裁剪 
 */
const fnSnapshot = async () => {
    const oTool = oCamera.value;
    if (!oTool) return;
    const [video, second] = oTool.$el.parentElement.querySelectorAll('video');
    if (!video || second){
        console.log('视频情况异常', video, second); 
    }
    const fRatio = video.videoHeight / video.videoWidth;
    const width = 1080;
    const height = Math.floor(width * fRatio);
    const blob = await oTool?.snapshot(
        { width, height },
        "image/jpg",
    );
    if (!blob){
        return console.error('拍照失败'); ;
    }
    const url = URL.createObjectURL(blob);
    if (0 && import.meta.dev){
        const oImg = Object.assign(new Image(), {
            src: url,
        });
    }
    oPicture4clip.value = url; 
    showFilmingStage.value = false;
    await nextTick(); 
    showPicCuttingStage.value = true;
    PicCuttinginitialize();
}

/**
 * 切换摄像头 
 */
const switchCamera = async ()=>{
    const oTool = oCamera.value;
    if (!oTool) return;
    const sOldID = oTool.currentDeviceID();
    const aDevices = await oTool.devices();
    const oNewOne = aDevices.find(cur => {
        return (
            !!cur.deviceId
            && (cur.deviceId != sOldID)
        );
    });
    if (!oNewOne) {
        return;
    }
    console.log('oTool\n', oTool);
    console.log('aDevices\n', aDevices); 
    oTool.changeCamera(oNewOne.deviceId);
}

/**
 * 监听文件选择，并保存 
 */
const fnSetFile = (ev)=>{
    const [file] = ev?.target?.files || [];
    console.log('file', file);
    if (!file) return; 
    oPicture4clip.value = URL.createObjectURL(file);
    showCuttingStage(); 
    ev.target.value = null; // 最后清空
};



/**
 * 开始上传（裁剪完毕了） 
 */
const fnConfirmAndUpload = async ()=>{
    showFilmingStage.value = false;
    showPicCuttingStage.value = false;
    sUploadingStatus.value = 'uploading';
    const oDelay = Sleep(iLoadingAnimation); 
    const type = 'image/jpeg'; 
    if (!oMyCropper) {
        return console.error('裁剪组件未加载 at fnConfirmAndUpload()');
    }
    const oCanvas01 = oMyCropper.getCropperSelection();
    const oCanvasDOM = await oCanvas01.$toCanvas(); 
    const oResolvers = Promise.withResolvers();
    oCanvasDOM.toBlob(oResolvers.resolve, type);
    const oCanvasBlob = await oResolvers.promise; 
    oPictureCipped.value = URL.createObjectURL(oCanvasBlob as any);
    const oData = {
        file: new File(
            [oCanvasBlob as any],
            `avatar_${Date.now()}.jpg`,
            { type },
        ),
    };
    // ↓ 执行后可在 network 面板浏览此图 
    if (1 && import.meta.dev){
        Object.assign(new Image(), {src: oPictureCipped.value});
    }
    // if (
    //     import.meta.env.DEV_MODE
    //     && Math.random() < 0.4
    //     && Date.now() < new Date('2025-06-22').getTime() 
    // ){
    //     console.error('人造报错-上传图'); 
    //     oData.file = '';
    // }
    const res = await UPLOAD_FILE(oData);
    if (!res || res['error'] || !res['url']){ 
        sUploadingStatus.value = 'uploadFailed';
        return console.error('上传失败', res);
    }
    const reply = await fnEmitAvatarURL(
        res['url'],
    );
    if (!reply) return;
    // ↓ 给上传动画一点播放时间 
    await oDelay; 
    sUploadingStatus.value = 'uploaded';
}

/**
 * 提交默认头像 
 */
const setDefaultAvatar = async ()=>{
    sUploadingStatus.value = 'uploading';
    const sChosen = oAvatar[sAvatarChosen.value];
    console.log('sChosen', sChosen); 
    oPictureCipped.value = sChosen;
    const oDelay = Sleep(iLoadingAnimation); 
    const res = await fnEmitAvatarURL(
        // ↓ 一定要添加 sDefaultAvatarPrefix 前缀，将来用此前缀判断是否为默认头像 
        `${sDefaultAvatarPrefix}${sAvatarChosen.value}`,
    );
    if (!res) return;
    // ↓ 给上传动画一点播放时间 
    await oDelay; 
    sUploadingStatus.value = 'uploaded';
}

/**
 * 提交头像 URL 
 */
const fnEmitAvatarURL = async (
    avatar: string,
)=>{
    // if (
    //     import.meta.env.DEV_MODE
    //     && Math.random() < 0.4
    //     && Date.now() < new Date('2025-06-22').getTime() 
    // ){
    //     console.error('人造报错-上传URL'); 
    //     avatar = ''; 
    // }
    const res = await EMIT_NEW_AVATAR({
        avatar,
    });
    if (!res || res['error']){
        sUploadingStatus.value = 'uploadFailed';
        // ↓ 不弹出提示，通过 uploadFailed 提示失败 
        // showNegativeNotify(res?.['error']);
        console.error('上传头像地址未成功', res); 
        return;
    }
    userStore.avatar = avatar; 
    return res; 
}

/**
 * 加载裁剪组件 
 */
async function PicCuttinginitialize(){
    if (1 && import.meta.dev && !oPicture4clip.value){
        const oAvatar = getAvatars();
        oPicture4clip.value = Object.values(oAvatar)[~~Math.random()];
    }
    const oResolvers = Promise.withResolvers();
    const image = Object.assign(new Image(), {
        src: oPicture4clip.value,
        onload(){
            oResolvers.resolve(true);
        },
    });
    await oResolvers.promise; 
    const {default: Cropper} = await oCropperModule;
    // console.log('image', image);
    // console.log('Cropper', Cropper);
    oMyCropper = new Cropper(image, {
        container: oContainerDOM.value,
        template: `
            <cropper-canvas
                background="false"
                style="width: 100%; height: ${sCropperCanvasHeight};"
            >
                <cropper-image
                    rotatable="true"
                    scalable
                    translatable
                ></cropper-image>
                <cropper-shade
                    hidden
                    theme-color="rgba(0, 0, 0, 0.7)"
                ></cropper-shade>
                <cropper-selection
                    initial-coverage="0.5"
                    movable="false"
                    resizable="false"
                    aspect-ratio="1"
                    initial-aspect-ratio="1"
                >
                    <cropper-grid role="grid" bordered covered></cropper-grid>
                    <cropper-crosshair centered></cropper-crosshair>
                    <cropper-handle
                        action="move"
                        theme-color="rgba(255, 255, 255, 0.35)"
                        style="border-radius: 200px"
                    ></cropper-handle>
                    <cropper-handle action="n-resize"></cropper-handle>
                    <cropper-handle action="e-resize"></cropper-handle>
                    <cropper-handle action="s-resize"></cropper-handle>
                    <cropper-handle action="w-resize"></cropper-handle>
                    <cropper-handle action="ne-resize"></cropper-handle>
                    <cropper-handle action="nw-resize"></cropper-handle>
                    <cropper-handle action="se-resize"></cropper-handle>
                    <cropper-handle action="sw-resize"></cropper-handle>
                </cropper-selection>
            </cropper-canvas>
        `,
    }); 
    await nextTick();
    fnResetPic2Center(); 
}

watch(()=>oRoute.path, (sNewPath)=>{
    if (sFirstPath == sNewPath) return; 
    if (1 && import.meta.dev){
        console.log(`url changed =>\n${sFirstPath}\n${sNewPath}`);
    }
    onUpdateModelVisible(false);
});


onMounted(()=>{
    // 
});

onBeforeUnmount(()=>{
    [
        oPicture4clip.value,
        oPictureCipped.value,
    ].forEach(cur=>{
        cur && URL.revokeObjectURL(cur);
    });
});

</script>

<style lang="scss" scoped>
.uploading-box{
    display: flex;
    justify-content: center; 
    align-items: center;
    flex-direction: column;
    padding: 0 0 20px;
    .uploading-tips{
        color: white; 
        padding: 20px 0 10px;
        display: flex;
        justify-content: center;
        align-items: center; 
        .q-icon{
            font-size: 1.2em;
            margin: 0 0 0 3px; 
        }
    }
}

.default-list{
    display: flex;
    justify-content: center;
    overflow: auto;
    flex-wrap: wrap; 
    padding: 0 0 10px;
    margin: 0 -10px 0 0;
    & > li{
        margin: 0 10px 10px 0;
        position: relative; 
    }
    .tick{
        width: 16px;
        height: 16px;
        border-radius: 100px;
        background: #00C672;
        position: absolute;
        bottom: -2px;
        left: 50%;
        transform: translateX(-50%);
        display: flex; 
        justify-content: center;
        align-items: center;
        color: white; 
        font-size: 12px;
        opacity: 0;
    }
    .user-avatar{
        border: solid 4px var(--bg006);

    }
    li.active{
        .user-avatar{
            border-color: #0077FF80;
        }
        .tick{
            opacity: 1;
        }
    }
}

.confirm-bar{
    display: flex;
    justify-content: center; 
    margin: 10px 0 10px;
    button + button{
        margin-left: 8px; 
    }
}

.btn-group{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px 0 0;
}
.gray-button{
    font-size: 14px; 
    font-weight: 500;
}

.btn-gray{
    width: calc(50% - 7px);
    background: var(--bg007);
    height: 48px;
    line-height: 48px;
    border-radius: 8px;
    color: white;
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    cursor: pointer; 
    &:hover{
        background: var(--bg005);
    }
    .q-icon{
        color: var(--bg003);
        font-size: 1.4em; 
        margin: 0 3px 0 0; 
    }
}


.cutting-stage{
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(16, 22, 34);
    transition: opacity 0.3s ease;
    display: flex;
    flex-flow: column;
    .top-area{
        width: 100%; 
        margin: 10vh 0 30px;
        background-color: #05070A; 
    }
    .btn-bar{
        display: flex;
        justify-content: space-between; 
        color: white;
        margin: auto 25px 16px;
        button{
            width: calc(50% - 7px); 
        }
    }
}

.filming-stage{
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    // background-color: rgb(16, 22, 34, 0.5);
    background-color: rgb(240, 240, 240, 1);
    transition: opacity 0.3s ease;
    // display: flex;
    .floating-btns{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 20px 30px;
        background-color: rgb(0, 0, 0, 0.8); 
        color: white;
        display: flex;
        justify-content: space-between; 
        align-items: center; 
        font-size: 30px;
        line-height: 1;
    }
    .snapshot{
        font-size: 1.5em; 
    }
}
</style>

